import { createFileRoute } from '@tanstack/react-router'
import ContractDetails from '../components/contract-details/ContractDetails'

export const Route = createFileRoute('/_a/contracts/$contractId')({
  component: ContractDetails,
})
